import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ProposalSection.module.scss';

export const ProposalSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles['section-open']} id="propuesta">
      
      <div className={`${styles['section-head']} ${styles['section-head--split']} ${styles['section-head--proposal']}`}>
        <p className={styles['eyebrow']}>
          {t('landing.proposal.eyebrow', 'Propuesta')}
        </p>
        <h2 
          className={styles['section-title']} 
          dangerouslySetInnerHTML={{ __html: t('landing.proposal.title', 'Más que una plataforma,<br/>una comunidad con<br/>propósito') }}
        />
        <p className={styles['section-copy']}>
          {t('landing.proposal.copy', 'Bodhiwell no busca solamente reunir perfiles en un mismo espacio. Busca construir una comunidad profesional donde distintas trayectorias y enfoques puedan encontrarse, dialogar y enriquecerse mutuamente, al mismo tiempo que ofrece herramientas concretas para dar visibilidad, ordenar la presencia profesional y facilitar la gestión de la práctica.')}
        </p>
      </div>

      <div className={`${styles['grid-3']} ${styles['value-cards']}`}>
        <article className={styles['value-item']}>
          <h3 className={styles['value-item__title--visibilidad']}>{t('landing.proposal.cards.visibilidad.title', 'Visibilidad')}</h3>
          <p>{t('landing.proposal.cards.visibilidad.desc', 'Hacé visible tu perfil, tu recorrido y tu enfoque para que más personas puedan comprender tu forma de acompañar.')}</p>
        </article>
        <article className={styles['value-item']}>
          <h3>{t('landing.proposal.cards.organizacion.title', 'Organización')}</h3>
          <p>{t('landing.proposal.cards.organizacion.desc', 'Ordená tu presencia dentro de la plataforma, integrando información, disponibilidad y recursos en un mismo espacio.')}</p>
        </article>
        <article className={styles['value-item']}>
          <h3>{t('landing.proposal.cards.gestion.title', 'Gestión')}</h3>
          <p>{t('landing.proposal.cards.gestion.desc', 'Contá con herramientas para administrar aspectos clave de tu práctica y facilitar el vínculo con las personas que buscan acompañamiento.')}</p>
        </article>
      </div>

    </section>
  );
};